import React, { useEffect, useState } from 'react';
import axios from 'axios';
const Footer = () => {
  const [data, setData] = useState([]);
  const getdata = async () => {
    const res = await axios.get(
      'https://portfolio-node-7hlx.onrender.com/getabout'
    );
    setData(res.data);
  };
  useEffect(async () => {
    getdata();
    const dat = localStorage.getItem('m-aj-cv');
    if (!dat) {
      let val = Math.floor(Math.random() * 10000000000);
      localStorage.setItem('m-aj-cv', val * val);
      const res = await axios.get(
        'https://portfolio-node-7hlx.onrender.com/postViewers'
      );
      // console.log(res.data)
    }
  }, []);

  return (
    <div className="footer">
      <div className="container">
        <div className="row ">
          <div className="col-lg-6 col-md-6 col-12 mx-auto p-5">
            <div className="text-center">
              {data?.map((val, ind) => (
                <a
                  key={ind}
                  href={`tel:${val.phone}`}
                  className="btn btn-warning"
                >
                  Hire Me
                </a>
              ))}{' '}
              &nbsp; &nbsp;{' '}
              <a
                href="https://internshala.com/student/resume_download/299B01F7-9D14-48BE-7C0B-E045D5FB21E4/8479523"
                target="_blank"
                rel="noreferrer"
                className="btn btn-dark"
              >
                Download Cv
              </a>
              <br />
              <h3>
                {' '}
                I’m looking to collaborate on any innovative project as a Full
                Stack Developer
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
